
import axios from './setting';


export default {


  //获取用户信息
  getUserInformation(params) {
    return axios.get('api/wechart/index/', { params: params })
  },


   //获取用户openid
   getUserOpenid(params) {
    return axios.get('api/wechart/openid/', { params: params })
  },

  //认证用户获取短信验证码
  getPhoneCode(params) {
    return axios.get('api/wechart/technician_sms/', { params: params })
  },

  //认证用户提交信息
  postRegistMessage(params) {
    return axios.post('api/wechart/technician_auth/', params)
  },

  //获取常见问题列表
  getQuestionList(params) {
    return axios.get(`api/wechart/questions/`, params)
  },

  //获取设备信息
  getDeviceInformation(params) {
    return axios.get(`api/wechart/devices/`, params)
  },


  getsha1code(params) {
    return axios.get('api/wechart/sha1/', params)
  },


  //故障报修
  faultpost(params) {
    return axios.post('api/wechart/fault/', params)
  },


  //意见反馈
  postSuggestion(params) {
    return axios.post('api/wechart/feedback/', params)
  },

  

  //购买设备
  buydevice(params) {
    return axios.post('api/wechart/device_try/', params)
  },


  //获取通知列表
  getMessages(){
    return axios.get('api/wechart/message/')
  },


   //获取通知列表
   getRewardInfomation(){
    return axios.get('api/wechart/award/')
  },

  
  //获取技师奖励信息
  getjsRewardInfomation(){
    return axios.get('api/wechart/technician/')
  },
  
  //申请奖励
  getapply(params){
    return axios.get('api/wechart/award/apply/',params)
  },

  getPayInforMation(params){
    return axios.post('api/wechart/payment/',params)
  }


 

} 


// WEBPACK FOOTER //
// ./src/api/wxapi.js